function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_125",
  "data-name": "Group 125",
  transform: "translate(-203 -416)"
}, React.createElement("g", {
  id: "Group_163",
  "data-name": "Group 163"
}, React.createElement("rect", {
  id: "Rectangle",
  "data-name": "Rectangle 148",
  width: 120,
  height: 80,
  transform: "translate(203 416)",
  fill: "#22509f"
}), React.createElement("path", {
  id: "Path",
  "data-name": "Path 172",
  d: "M555,129.971c-16.008-.611-28.268-15.294-42.413-32.252-11.34-13.6-23.608-28.282-39.731-37.719H435V70.027c.346-.007.684-.027,1.034-.027,27.385,0,43.808,19.687,61.2,40.53,9.022,10.816,18.218,21.833,29.07,29.47H555Z",
  transform: "translate(-232 356)",
  fill: "#062b71"
})));

var SvgWaveIconS1 = function SvgWaveIconS1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWaveIconS1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wave-icon-S1.1e1f6ed5.svg";
export { ForwardRef as ReactComponent };